// Tamil translations for Panchang values (Tithi, Nakshatra, Yoga, Paksha, Rashi)

export const tithiTamil = {
  'Shukla': 'சுக்ல',
  'Krishna': 'கிருஷ்ண',
  'Pratipada': 'பிரதமை',
  'Prathama': 'பிரதமை',
  'Dwitiya': 'துவிதியை',
  'Tritiya': 'திருதியை',
  'Chaturthi': 'சதுர்த்தி',
  'Panchami': 'பஞ்சமி',
  'Shashti': 'சஷ்டி',
  'Saptami': 'சப்தமி',
  'Ashtami': 'அஷ்டமி',
  'Navami': 'நவமி',
  'Dashami': 'தசமி',
  'Ekadasi': 'ஏகாதசி',
  'Ekadashi': 'ஏகாதசி',
  'Dwadasi': 'துவாதசி',
  'Dwadashi': 'துவாதசி',
  'Trayodasi': 'திரயோதசி',
  'Trayodashi': 'திரயோதசி',
  'Chaturdasi': 'சதுர்த்தசி',
  'Chaturdashi': 'சதுர்த்தசி',
  'Purnima': 'பூர்ணிமா',
  'Amavasya': 'அமாவாசை',
  'Amavasai': 'அமாவாசை',
};

export const nakshatraTamil = {
  'Ashwini': 'அசுவினி',
  'Bharani': 'பரணி',
  'Krittika': 'கிருத்திகை',
  'Rohini': 'ரோகிணி',
  'Mrigashirsha': 'மிருகசீரிடம்',
  'Mrigasheersham': 'மிருகசீரிடம்',
  'Ardra': 'திருவாதிரை',
  'Thiruvathirai': 'திருவாதிரை',
  'Punarvasu': 'புனர்பூசம்',
  'Punarpoosam': 'புனர்பூசம்',
  'Pushya': 'பூசம்',
  'Poosam': 'பூசம்',
  'Ashlesha': 'ஆயில்யம்',
  'Ayilyam': 'ஆயில்யம்',
  'Magha': 'மகம்',
  'Magam': 'மகம்',
  'Purva Phalguni': 'பூரம்',
  'Pooram': 'பூரம்',
  'Uttara Phalguni': 'உத்திரம்',
  'Uthiram': 'உத்திரம்',
  'Hasta': 'அஸ்தம்',
  'Hastham': 'அஸ்தம்',
  'Chitra': 'சித்திரை',
  'Chithirai': 'சித்திரை',
  'Swati': 'சுவாதி',
  'Swathi': 'சுவாதி',
  'Vishakha': 'விசாகம்',
  'Visakam': 'விசாகம்',
  'Anuradha': 'அனுஷம்',
  'Anusham': 'அனுஷம்',
  'Jyeshtha': 'கேட்டை',
  'Kettai': 'கேட்டை',
  'Mula': 'மூலம்',
  'Moolam': 'மூலம்',
  'Purva Ashadha': 'பூராடம்',
  'Pooradam': 'பூராடம்',
  'Uttara Ashadha': 'உத்திராடம்',
  'Uthiradam': 'உத்திராடம்',
  'Shravana': 'திருவோணம்',
  'Thiruvonam': 'திருவோணம்',
  'Dhanishta': 'அவிட்டம்',
  'Avittam': 'அவிட்டம்',
  'Shatabhisha': 'சதயம்',
  'Sathayam': 'சதயம்',
  'Purva Bhadrapada': 'பூரட்டாதி',
  'Poorattathi': 'பூரட்டாதி',
  'Uttara Bhadrapada': 'உத்திரட்டாதி',
  'Uthirattathi': 'உத்திரட்டாதி',
  'Revati': 'ரேவதி',
  'Revathi': 'ரேவதி',
};

export const yogaTamil = {
  'Vishkambha': 'விஷ்கம்பம்',
  'Preeti': 'பிரீதி',
  'Priti': 'பிரீதி',
  'Ayushman': 'ஆயுஷ்மான்',
  'Saubhagya': 'சௌபாக்யம்',
  'Shobhana': 'சோபனம்',
  'Atiganda': 'அதிகண்டம்',
  'Sukarma': 'சுகர்மம்',
  'Dhriti': 'திருதி',
  'Shoola': 'சூலம்',
  'Ganda': 'கண்டம்',
  'Vriddhi': 'விருத்தி',
  'Dhruva': 'துருவம்',
  'Vyaghata': 'வியாகாதம்',
  'Harshana': 'அர்ஷணம்',
  'Vajra': 'வஜ்ரம்',
  'Siddhi': 'சித்தி',
  'Vyatipata': 'வியதீபாதம்',
  'Variyan': 'வரியான்',
  'Parigha': 'பரிகம்',
  'Siva': 'சிவம்',
  'Shiva': 'சிவம்',
  'Siddha': 'சித்தம்',
  'Sadhya': 'சாத்தியம்',
  'Shubha': 'சுபம்',
  'Shukla': 'சுக்லம்',
  'Brahma': 'பிரம்மம்',
  'Indra': 'இந்திரம்',
  'Vaidhriti': 'வைத்ருதி',
};

export const pakshaTamil = {
  'Shukla': 'சுக்ல',
  'Krishna': 'கிருஷ்ண',
};

export const rashiTamil = {
  'Mesha': 'மேஷம்',
  'Aries': 'மேஷம்',
  'Vrishabha': 'ரிஷபம்',
  'Taurus': 'ரிஷபம்',
  'Mithuna': 'மிதுனம்',
  'Mithunam': 'மிதுனம்',
  'Gemini': 'மிதுனம்',
  'Karka': 'கடகம்',
  'Katakam': 'கடகம்',
  'Cancer': 'கடகம்',
  'Simha': 'சிம்மம்',
  'Leo': 'சிம்மம்',
  'Kanya': 'கன்னி',
  'Virgo': 'கன்னி',
  'Thula': 'துலாம்',
  'Tula': 'துலாம்',
  'Libra': 'துலாம்',
  'Vrischika': 'விருச்சிகம்',
  'Scorpio': 'விருச்சிகம்',
  'Dhanu': 'தனுசு',
  'Sagittarius': 'தனுசு',
  'Makara': 'மகரம்',
  'Capricorn': 'மகரம்',
  'Kumbha': 'கும்பம்',
  'Aquarius': 'கும்பம்',
  'Meena': 'மீனம்',
  'Pisces': 'மீனம்',
};

export const tamilYogaTamil = {
  'Amrutha': 'அமிர்தம்',
  'Siddha': 'சித்தம்',
  'Marana': 'மரணம்',
  'Uthi': 'உத்தி',
  'Roga': 'ரோகம்',
};

// Helper function to translate a panchang value
// Handles compound names like "Krishna Ekadasi" by translating each word
export const translatePanchangValue = (value, mapping) => {
  if (!value) return value;
  // Try exact match first
  if (mapping[value]) return mapping[value];
  // Try case-insensitive exact match
  for (const [key, tamil] of Object.entries(mapping)) {
    if (value.toLowerCase() === key.toLowerCase()) return tamil;
  }
  // Try splitting into words and translating each part
  const words = value.split(' ');
  if (words.length > 1) {
    const translated = words.map(word => {
      if (mapping[word]) return mapping[word];
      for (const [key, tamil] of Object.entries(mapping)) {
        if (word.toLowerCase() === key.toLowerCase()) return tamil;
      }
      return word;
    });
    // Only return translated if at least one word was translated
    if (translated.some((w, i) => w !== words[i])) {
      return translated.join(' ');
    }
  }
  return value;
};
